import { Col, Row } from "react-bootstrap";
import upwork from "../assets/img/links/upwork.png"
import linkedin from "../assets/img/links/linkedin.svg"
import github from "../assets/img/links/github.svg"
import mostaql from "../assets/img/links/mostaql.jpeg"

const linksData = [
  { name: 'LinkedIn', href: 'https://www.linkedin.com/in/abderaouf-layadi-45324a276/?locale=en_US', img: linkedin },
  { name: 'Upwork', href: 'https://www.upwork.com/freelancers/~01aeea39dd84c4f4dc?mp_source=share', img: upwork },
  { name: 'GitHub', href: 'https://github.com/layadi-abderaouf', img: github },
  { name: 'Mostaql', href: 'https://mostaql.com/u/raouf_layadi', img: mostaql },
];

export const Newsletter = () => {
  return (
    <Col lg={12}>
      <div id="Links"className="newsletter-bx wow slideInUp" style={{textAlign: 'center'}}>
        <h2 style={{marginBottom: 8}}>Links</h2>
        <p style={{opacity: 0.85, marginBottom: 24}}>Find me on these platforms</p>
        <Row className="justify-content-center">
          {linksData.map((item) => (
            <Col key={item.name} xs={6} sm={4} md={3} className="d-flex flex-column align-items-center mx-4 mx-md-0 mb-3">
              <a href={item.href} target="_blank" rel="noopener noreferrer" className="d-flex flex-column align-items-center" style={{color: 'inherit'}}>
                <img src={item.img} alt={item.name} style={{width: 100, height: 100, objectFit: 'contain', marginBottom: 8, }} />
                <span>{item.name}</span>
              </a>
            </Col>
          ))}
        </Row>
      </div>
    </Col>
  )
}
